export const yesNoOptions = [
  { text: 'Yes', value: true },
  { text: 'No', value: false },
];
